import LocalStorage from "../../const/LocalStorage";

export function execute() {
  localStorage.removeItem(LocalStorage.CUSTOMER_DATA_CALLCENTER); 
	localStorage.removeItem(LocalStorage.AD_LOGIN_CALLCENTER);
  window.location.replace(global.env.CALLCENTER_LOGOUT_URL);
}



// WEBPACK FOOTER //
// ./src/usecases/logoutCallcenter/LogoutCallcenterUC.js